var _radialGradient, _path, _radialGradient2, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SrYuS0MYDGH9m0SRC6_noa",
    cx: 31.417,
    cy: -1098.083,
    r: 28.77,
    gradientTransform: "translate(0 1128)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4e09d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#f8e8b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#fcf0cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#fef4dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6e1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SrYuS0MYDGH9m0SRC6_noa)",
    d: "M7.5,64L7.5,64c1.933,0,3.5-1.567,3.5-3.5l0,0c0-1.933-1.567-3.5-3.5-3.5l0,0 C5.567,57,4,58.567,4,60.5l0,0C4,62.433,5.567,64,7.5,64z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SrYuS0MYDGH9m0SRC6_nob",
    cx: 31.5,
    cy: -1096,
    r: 31.751,
    gradientTransform: "translate(0 1128)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4e09d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#f8e8b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#fcf0cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#fef4dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6e1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SrYuS0MYDGH9m0SRC6_nob)",
    d: "M62,20.5L62,20.5c0-2.485-2.015-4.5-4.5-4.5H49c-2.209,0-4-1.791-4-4l0,0 c0-2.209,1.791-4,4-4h2c2.209,0,4-1.791,4-4l0,0c0-2.209-1.791-4-4-4H20c-2.209,0-4,1.791-4,4l0,0c0,2.209,1.791,4,4,4h2 c1.657,0,3,1.343,3,3l0,0c0,1.657-1.343,3-3,3H7.5C5.567,14,4,15.567,4,17.5l0,0C4,19.433,5.567,21,7.5,21H9c1.657,0,3,1.343,3,3 l0,0c0,1.657-1.343,3-3,3H5c-2.761,0-5,2.239-5,5l0,0c0,2.761,2.239,5,5,5h2.5c1.933,0,3.5,1.567,3.5,3.5l0,0 c0,1.933-1.567,3.5-3.5,3.5H6c-2.209,0-4,1.791-4,4l0,0c0,2.209,1.791,4,4,4h11.5c1.381,0,2.5,1.119,2.5,2.5l0,0 c0,1.381-1.119,2.5-2.5,2.5l0,0c-1.933,0-3.5,1.567-3.5,3.5l0,0c0,1.933,1.567,3.5,3.5,3.5h35c1.933,0,3.5-1.567,3.5-3.5l0,0 c0-1.933-1.567-3.5-3.5-3.5H52c-1.105,0-7-0.895-7-2l0,0c0-1.105,0.895-2,2-2h12c2.209,0,4-1.791,4-4l0,0c0-2.209-1.791-4-4-4h-2.5 c-1.381,0-2.5-1.119-2.5-2.5l0,0c0-1.381,1.119-2.5,2.5-2.5H57c2.209,0,4-1.791,4-4l0,0c0-2.209-1.791-4-4-4h-4.5 c-1.933,0-3.5-1.567-3.5-3.5l0,0c0-1.933,1.567-3.5,3.5-3.5h5C59.985,25,62,22.985,62,20.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SrYuS0MYDGH9m0SRC6_noc",
    x1: 32,
    x2: 32,
    y1: 53,
    y2: 8,
    gradientTransform: "matrix(1 0 0 -1 0 64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#def9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#cff6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#a7efff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99ecff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SrYuS0MYDGH9m0SRC6_noc)",
    d: "M15.211,11h33.578c3.024,0,5.356,2.663,4.956,5.661l-4.667,35 C48.747,54.145,46.628,56,44.122,56H19.878c-2.506,0-4.625-1.855-4.956-4.339l-4.667-35C9.855,13.663,12.187,11,15.211,11z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SrYuS0MYDGH9m0SRC6_nod",
    x1: 32,
    x2: 32,
    y1: 46,
    y2: 56,
    gradientTransform: "matrix(1 0 0 -1 0 64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41bfec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#4cc5ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#6bd4f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ae4fd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SrYuS0MYDGH9m0SRC6_nod)",
    d: "M53,18H11c-1.105,0-2-0.895-2-2v-6c0-1.105,0.895-2,2-2h42c1.105,0,2,0.895,2,2v6 C55,17.105,54.105,18,53,18z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SrYuS0MYDGH9m0SRC6_noe",
    x1: 52,
    x2: 52,
    y1: -1064,
    y2: -1088,
    gradientTransform: "translate(0 1128)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#ff5840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#fa528c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa528c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SrYuS0MYDGH9m0SRC6_noe)",
    d: "M52,40c-6.627,0-12,5.373-12,12s5.373,12,12,12s12-5.373,12-12S58.627,40,52,40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.417,49.412l-8.005,8.005c-0.778,0.778-2.051,0.778-2.828,0l0,0 c-0.778-0.778-0.778-2.051,0-2.828l8.005-8.005c0.778-0.778,2.051-0.778,2.828,0l0,0C58.194,47.361,58.194,48.634,57.417,49.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.583,49.412l8.005,8.005c0.778,0.778,2.051,0.778,2.828,0l0,0c0.778-0.778,0.778-2.051,0-2.828 l-8.005-8.005c-0.778-0.778-2.051-0.778-2.828,0l0,0C45.806,47.361,45.806,48.634,46.583,49.412z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a479d030a5d88ac23edc7d14031532d9.svg";
export { ForwardRef as ReactComponent };